const getters = {
  isLoading: state => state.app.isLoading
}
export default getters
